// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    /* Primitive tokens */
    --gw-space-0: 0px;
    --gw-space-025: 1px;
    --gw-space-050: 2px;
    --gw-space-075: 3px;
    --gw-space-100: 4px;
    --gw-space-150: 6px;
    --gw-space-200: 8px;
    --gw-space-250: 10px;
    --gw-space-300: 12px;
    --gw-space-400: 16px;
    --gw-space-450: 18px;
    --gw-space-500: 20px;
    --gw-space-600: 24px;
    --gw-space-800: 32px;
    --gw-space-1000: 40px;
    --gw-space-1200: 48px;
    --gw-space-1600: 64px;
    --gw-space-2000: 80px;
    --gw-space-2400: 96px;
    --gw-space-3200: 128px;

    /* Semantic polaris tokens */
    --gw-p-button-group-gap: var(--gw-space-200);
    --gw-p-card-gap: var(--gw-space-400);
    --gw-p-card-padding: var(--gw-space-400);
    --gw-p-table-cell-padding: var(--gw-space-150);
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/space.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;;IAEtB,4BAA4B;IAC5B,4CAA4C;IAC5C,oCAAoC;IACpC,wCAAwC;IACxC,8CAA8C;AAClD","sourcesContent":[":root,\n:host {\n    /* Primitive tokens */\n    --gw-space-0: 0px;\n    --gw-space-025: 1px;\n    --gw-space-050: 2px;\n    --gw-space-075: 3px;\n    --gw-space-100: 4px;\n    --gw-space-150: 6px;\n    --gw-space-200: 8px;\n    --gw-space-250: 10px;\n    --gw-space-300: 12px;\n    --gw-space-400: 16px;\n    --gw-space-450: 18px;\n    --gw-space-500: 20px;\n    --gw-space-600: 24px;\n    --gw-space-800: 32px;\n    --gw-space-1000: 40px;\n    --gw-space-1200: 48px;\n    --gw-space-1600: 64px;\n    --gw-space-2000: 80px;\n    --gw-space-2400: 96px;\n    --gw-space-3200: 128px;\n\n    /* Semantic polaris tokens */\n    --gw-p-button-group-gap: var(--gw-space-200);\n    --gw-p-card-gap: var(--gw-space-400);\n    --gw-p-card-padding: var(--gw-space-400);\n    --gw-p-table-cell-padding: var(--gw-space-150);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
